import { FilterItemConfig } from '../types/filter-config';
import { FilterOperator } from '../types/filter-operators';

const COMMON_OPERATORS = ['in', 'notIn', 'empty', 'notEmpty'];
const SCALAR_OPERATORS: Record<string, string[]> = {
  boolean: ['true', 'false'],
  string: ['equals', 'notEquals', 'contains', 'startsWith', 'endsWith', 'like'],
  number: ['equals', 'notEquals', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual', 'between'],
  date: ['equals', 'notEquals', 'before', 'after', 'beforeOrEquals', 'afterOrEquals', 'between'],
  dateTime: ['equals', 'notEquals', 'before', 'after', 'beforeOrEquals', 'afterOrEquals', 'between'],
  dateTimeTz: ['equals', 'notEquals', 'before', 'after', 'beforeOrEquals', 'afterOrEquals', 'between'],
  // entity equals/notEquals stays excluded while SelectFilterInputComponent is a stub
  entity: [],
  custom: [],
};

/** Operators of an item the custom builder can render a value input for. */
export function getBuilderOperators<T extends object>(
  config: FilterItemConfig<T>
): FilterOperator[] {
  const supported = [...COMMON_OPERATORS, ...(SCALAR_OPERATORS[config.type] ?? [])];
  return (config.allowedOperators as FilterOperator[]).filter((o) => supported.includes(o));
}

/** true when the operator carries its value implicitly (no value input needed). */
export function isValuelessOperator(operator: FilterOperator): boolean {
  return operator === 'empty' || operator === 'notEmpty' || operator === 'true' || operator === 'false';
}
